import React, { useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import FieldQty from '../fields/FieldQty';
import CartImage from '../common/CartImage';
// import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import Numeral from 'numeral';
import $ from 'jquery';
import {
    getCartItemTotalPrice,
    getFinalBuyableLink,
} from '../../selectors/cartSelector';
import { currencyDisplay, __currencyDisplay } from '../../_utils';
import { calculateNearestCartQty } from '../../selectors/tagWizardSelector';
import classnames from 'classnames';
import TagReviewBulletItem from '../ProductTagWizard/Elements/TagReviewBulletItem';

function OrderItem(props) {
    const {
        item,
        onQuantityUpdate
    } = props;
    const {
        ID,
        InternalItemID,
        Title,
        TotalUnitItems,
        Notes = '',
        ParentItemID,
        BackOrderQuantity = 0,
        TagSummaryData
    } = item;


    const TagSummaryDetail = TagSummaryData ? JSON.parse(window.decodeJsonFromBase64(TagSummaryData)) : [];

    // State Manager
    const [isDeleting, setIsDeleting] = useState(false);
    const [qtyPicked, setQtyPicked] = useState(null);
    const [backOrderQuantity, setBackOrderQuantity] = useState(null);
    const [children, setChildren] = useState(null);
    const cartModalItemKey = `cart-summary-item-${ID}`;


    const handleQuantityUpdate = (target, newValue) => {
        if (newValue >= 0 && newValue <= TotalUnitItems) {
            setQtyPicked(newValue);
            let remainingQty = Number(TotalUnitItems) - Number(newValue);
            setBackOrderQuantity(remainingQty);
            onQuantityUpdate(ID, newValue, remainingQty)
            if (children?.length > 0) {

                let childrenUpdated = children.map(item => {
                    return {
                        ...item,
                        TotalUnitItems: newValue,
                        BackOrderQuantity: remainingQty
                    }
                });
                setChildren(childrenUpdated);
            }
        }

    };

    useEffect(() => {
        setQtyPicked(TotalUnitItems);
        setBackOrderQuantity(BackOrderQuantity);
        if (item?.Children?.length > 0) {
            setChildren(item?.Children);
        }
    }, []);

    const showTagSummary = TagSummaryDetail.length > 0;
    const showNotes = !!Notes;
    const showSummaryNotesSection = showTagSummary || showNotes;

    return (
        <>
            <div
                className={classnames(
                    'data-table__tr-group cart-summary__tr-group cart-summary__tr-group--main',
                    ParentItemID > 0 && 'dt-cart-summary--sub'
                )}
                id={cartModalItemKey}
            >
                <div className='cart-summary__indent'>
                    <span className='icon-indent-arrow'></span>
                </div>
                <div className='data-table__tr cart-summary__tr'>
                    <div className='data-table__td dt-cart-summary__image'>
                        <CartImage item={item} />
                    </div>
                    <div className='data-table__td dt-cart-summary'>
                        <span className='data-table__info data-table__info--default'>
                            <span className='product__code'>{InternalItemID}</span>
                        </span>
                    </div>
                    <div className='data-table__td dt-cart-summary'>
                        <span className='data-table__info data-table__info--default'>
                            <span className='product__code'>{Title}</span>
                            {showSummaryNotesSection &&
                                <div class="hidden-xs">
                                    {showTagSummary && <div class="order-item-extra">
                                        <div class="order-item-extra__title">Summary</div>
                                        <div class="order-item-extra__content">
                                            <ul>
                                                {TagSummaryDetail?.map((listItem, listItemIndex) => {
                                                    const { Title, Value, Children = [] } = listItem;
                                                    return (
                                                        <li key={listItemIndex}>
                                                            <TagReviewBulletItem
                                                                title={Title}
                                                                value={Value}
                                                                makeTitleStrong={true}
                                                            />
                                                            {Children && Children.length > 0}
                                                            <ul>
                                                                {Children.map((listSubitem, listSubitemIndex) =>
                                                                    <li key={listItemIndex + '-' + listSubitemIndex}>
                                                                        <TagReviewBulletItem
                                                                            title={listSubitem.Title}
                                                                            value={listSubitem.Value}
                                                                            makeTitleStrong={true}
                                                                        />
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>}
                                    {showNotes && <div class="order-item-extra">
                                        <div class="order-item-extra__title">Notes</div>
                                        <div class="order-item-extra__content">
                                            {Notes}
                                        </div>
                                    </div>
                                    }
                                </div>
                            }
                        </span>
                    </div>
                    <div className='data-table__td dt-cart-summary'>
                        <span className='data-table__info data-table__info--default'>
                            <span className='product__code'>{TotalUnitItems}</span>
                        </span>
                    </div>
                    <div className='data-table__td dt-cart-summary' style={{ flex: '2 0 0' }}>
                        {!ParentItemID ?
                            (
                                <FieldQty
                                    required
                                    disabled={false}
                                    name='TotalUnitItems'
                                    value={qtyPicked ?? ''}
                                    min={0}
                                    max={TotalUnitItems}
                                    step={1}
                                    onChange={handleQuantityUpdate}
                                    className='backorder-quantity-field'
                                />
                            ) : (
                                <span className='data-table__info'>
                                    {TotalUnitItems}
                                </span>
                            )
                        }
                    </div>
                    <div className='data-table__td dt-cart-summary'>
                        <span className='data-table__info'>
                            {!ParentItemID ? backOrderQuantity : BackOrderQuantity}
                        </span>
                    </div>
                </div>
            </div>
            {
                showSummaryNotesSection &&
                <div class="data-table__tr-group cart-summary__tr-group   visible-xs">
                    <div class="cart-summary__indent"></div>
                    <div class="data-table__tr data-table__tr--top" role="row">
                        <div class="data-table__td dt-cart-summary__extra">

                            {showTagSummary && <div class="order-item-extra">
                                <div class="order-item-extra__title">Summary</div>
                                <div class="order-item-extra__content">
                                    <ul>
                                        {TagSummaryDetail.map((listItem, listItemIndex) => {
                                            const { Title, Value, Children = [] } = listItem;
                                            return (
                                                <li key={listItemIndex}>
                                                    <TagReviewBulletItem
                                                        title={Title}
                                                        value={Value}
                                                        makeTitleStrong={true}
                                                    />
                                                    {Children && Children.length > 0}
                                                    <ul>
                                                        {Children.map((listSubitem, listSubitemIndex) =>
                                                            <li key={listItemIndex + '-' + listSubitemIndex}>
                                                                <TagReviewBulletItem
                                                                    title={listSubitem.Title}
                                                                    value={listSubitem.Value}
                                                                    makeTitleStrong={true}
                                                                />
                                                            </li>
                                                        )}
                                                    </ul>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>}


                            {showNotes && <div class="order-item-extra">
                                <div class="order-item-extra__title">Notes</div>
                                <div class="order-item-extra__content">
                                    {Notes}
                                </div>
                            </div>}

                        </div>
                    </div>
                </div>

            }
            {
                children?.map((subitem) => (
                    <OrderItem
                        key={subitem.ID}
                        item={subitem}
                    />
                ))
            }
        </>
    );
}

// default props
OrderItem.defaultProps = {
    // message: '',
};
// validate props
OrderItem.propTypes = {
    // message: PropTypes.string,
};

export default OrderItem;
